import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { initTracking, track } from './lib/track';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuickLinks from './components/QuickLinks';
import LeadCapture from './components/LeadCapture';
import LojaDatenPage from './pages/LojaDatenPage';
import NavegamerPage from './pages/NavegamerPage';
import Partners from './components/Partners';
import Services from './components/Services';
import RemoteSupport from './components/RemoteSupport';
import FAQ from './components/FAQ';
import About from './components/About';
import Clients from './components/Clients';
import BlingERP from './components/BlingERP';
import SHOficinaERP from './components/SHOficinaERP';
import DaniloContabilidadeBanner from './components/DaniloContabilidadeBanner';
import OnlineStore from './components/OnlineStore';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SideMenu from './components/SideMenu';
import CookieConsent from './components/CookieConsent';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookieSettingsButton from './components/CookieSettingsButton';
import AdminOrders from './components/AdminOrders';
import GoogleReview from './components/GoogleReview';
import GoogleMap from './components/GoogleMap';
import ComprarPage from './components/ComprarPage';
import Hospedagem from './components/Hospedagem';
import Intelbras from './components/Intelbras';
import Daten from './components/Daten';
import AssistenciaTecnica from './components/AssistenciaTecnica';
import OrcamentoIntelbras from './pages/OrcamentoIntelbras';
import AssistenciaTecnicaPage from './pages/AssistenciaTecnicaPage';
import DatenPage from './pages/DatenPage';
import ClientesVipPage from './pages/ClientesVipPage';
import SuporteRemotoNacionalPage from './pages/SuporteRemotoNacionalPage';
import BlogPage from './pages/BlogPage';
import AvaliacoesPage from './pages/AvaliacoesPage';
import ServicosTiPage from './pages/ServicosTiPage';
import ShoficinaPage from './pages/ShoficinaPage';
import BlingPage from './pages/BlingPage';
import QuemSomosPage from './pages/QuemSomosPage';
import IntelbrasPage from './pages/IntelbrasPage';
import SitesPage from './pages/SitesPage';
import HospedagemPage from './pages/HospedagemPage';
import AvaliacoesGoogle from './components/AvaliacoesGoogle';
import WhatsAppChatWidget from './components/WhatsAppChatWidget';
import { Toaster } from './components/ui/toaster';
import { Toaster as SonnerToaster } from './components/ui/sonner';

function MainSite() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);

  // Retorno do login Google (Emergent Auth) — abre o painel admin para processar o session_id
  useEffect(() => {
    if (window.location.hash.includes('session_id=')) setShowAdmin(true);
  }, []);

  const handleResetCookieConsent = () => {
    localStorage.removeItem('fernando-tech-cookie-consent');
    setShowCookieSettings(true);
    window.location.reload();
  };

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <QuickLinks />
      <Partners />
      <Services showLearnMore />
      <AssistenciaTecnica />
      <RemoteSupport />
      <BlingERP showLearnMore />
      <SHOficinaERP showLearnMore />
      <DaniloContabilidadeBanner />
      <Hospedagem showLearnMore />
      <Intelbras showLearnMore />
      <Daten />
      <OnlineStore />
      <LeadCapture />
      <About showLearnMore />
      <FAQ />
      {/* ── Prova social agrupada perto do rodapé ── */}
      <Clients />
      <AvaliacoesGoogle limit={3} showViewAll />
      <GoogleReview />
      <Contact />
      <GoogleMap />
      <Footer 
        onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)} 
        onOpenAdmin={() => setShowAdmin(true)}
      />
      <SideMenu />
      <CookieConsent onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)} />
      <PrivacyPolicy isOpen={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)} />
      <CookieSettingsButton onClick={handleResetCookieConsent} />
      <AdminOrders isOpen={showAdmin} onClose={() => setShowAdmin(false)} />
      <Toaster />
    </div>
  );
}

// Analytics próprio: pageview anônimo por rota + captura de cliques WhatsApp
function PageviewTracker() {
  const location = useLocation();
  useEffect(() => { initTracking(); }, []);
  useEffect(() => {
    track('pageview', { page: location.pathname, referrer: document.referrer || '' });
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <PageviewTracker />
      <Routes>
        <Route path="/comprar" element={<ComprarPage />} />
        <Route path="/orcamento-intelbras" element={<OrcamentoIntelbras />} />
        <Route path="/assistencia-tecnica" element={<AssistenciaTecnicaPage />} />
        <Route path="/daten" element={<DatenPage />} />
        <Route path="/clientes-vip" element={<ClientesVipPage />} />
        <Route path="/suporte-remoto-nacional" element={<SuporteRemotoNacionalPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPage />} />
        <Route path="/avaliacoes" element={<AvaliacoesPage />} />
        <Route path="/servicos-ti" element={<ServicosTiPage />} />
        <Route path="/shoficina" element={<ShoficinaPage />} />
        <Route path="/bling" element={<BlingPage />} />
        <Route path="/quem-somos" element={<QuemSomosPage />} />
        <Route path="/intelbras" element={<IntelbrasPage />} />
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/hospedagem" element={<HospedagemPage />} />
        <Route path="/loja-daten" element={<LojaDatenPage />} />
        <Route path="/navegamer" element={<NavegamerPage />} />
        <Route path="*" element={<MainSite />} />
      </Routes>
      {/* Widget de chat global — aparece em todas as páginas */}
      <WhatsAppChatWidget />
      {/* Toaster sonner para notificações de novos pedidos no admin */}
      <SonnerToaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
